module.exports = __webpack_public_path__ + "assets/bb01d5973009ebb1fba1cc1c984be5a2.png";